import Layout from "./Layout";
import { Link } from "react-router-dom";

export default function Success() {
  return (
    <Layout>
      <div className="min-h-screen flex flex-col items-center justify-center text-center p-6">
        <h1 className="text-4xl font-bold mb-4">🎉 Payment Successful!</h1>

        <p className="text-lg text-gray-600 mb-8">
          Thank you for your purchase. Your order has been placed successfully.
        </p>

        <Link
          to="/products"
          className="px-6 py-3 bg-black text-white rounded-lg text-lg font-medium hover:bg-gray-800 transition"
        >
          Continue Shopping
        </Link>
      </div>
    </Layout>
  );
}
